import rics from "routes/schedule/plugins/codes-tab/rics.png"
import uniclass from "routes/schedule/plugins/codes-tab/uniclass.png"

export const imageForClass = {
    rics,
    uniclass,
}
